// extracted by mini-css-extract-plugin
export default {"fixed-donate-button":"ADYls"};